module.exports = __webpack_public_path__ + "img/svg/visa.17547a352619b83715a90ca27c2f33f1.svg";